import { useTranslations } from "use-intl";

import { parseDuration } from "@/app/lib/utils/duration";
import type { FindFlightOffersFlightStopV2 } from "@/types/codegen";

type Props = {
  stops?: FindFlightOffersFlightStopV2[] | null;
  firstStopCity: string;
};

export const StopsLabel = ({ stops, firstStopCity }: Props) => {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-start">
      <div className="flex justify-between rounded-xl bg-surface-background px-2 py-1 text-sm font-medium text-text-primary">
        {stops && stops.length > 1 ? (
          <div>
            {stops.length} {t("flights.stops")}
          </div>
        ) : stops && stops.length === 1 ? (
          <div>
            {stops[0].stopTime
              ? `${t("durationValue", parseDuration(stops[0].stopTime))} `
              : null}
            {t("flights.stopInCity", {
              cityName: firstStopCity,
            })}
          </div>
        ) : (
          <div>{t("flights.directFlight")}</div>
        )}
      </div>
    </div>
  );
};
